import { useState, useEffect, useCallback, useRef } from "react";
import Upload from "antd/es/upload/Upload";
import { env } from "../../env";
import { message, type UploadFile } from "antd";
import { UseFormSetValue } from "react-hook-form";
import { UploadListType } from "antd/es/upload/interface";
import useTranslation from "utils/hooks/useTranslation";
import { getLocalStorageAccessToken } from "utils/helpers/localStorage";
import Button from "./button";
import { SvgDelete, SvgDownload, SvgPicture } from "components/svg";
import { getMemAppToken } from "utils/helpers/project";

interface CustomUploadProps {
  actionUrl?: string;
  type: string;
  dataItem: any;
  className?: string;
  anyFile?: boolean;
  hideLink?: boolean;
  skipDeleteIcon?: boolean;
  imageField: string;
  fileNameField?: string;
  alt?: string;
  multiple?: boolean;
  listType?: UploadListType;
  showUploadList?: boolean;
  keepName?: boolean;
  setValue: UseFormSetValue<any>;
  watch: any;
}

const CustomUpload: React.FC<CustomUploadProps> = ({
  actionUrl,
  type,
  dataItem,
  className,
  anyFile,
  hideLink,
  skipDeleteIcon,
  imageField,
  fileNameField,
  alt,
  multiple,
  // listType,
  showUploadList,
  keepName,
  setValue,
  watch,
}) => {
  // const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [blobImage, setBlobImage] = useState<string>();
  const { t } = useTranslation();
  const uploadRef = useRef(null);
  const duplicateNames = useRef([]);
  const uploadingCount = useRef(0);

  const api_url: string = `${env.api_url}/api`;

  const images = watch(imageField);


  useEffect(() => {

    if (images && images[0]) {
      let token = getLocalStorageAccessToken();
      if (!token) {
        token = getMemAppToken();

      }
      if (token) {
        const headers = {
          'Authorization': "Bearer " + token,
        };
        const fetchOptions = {
          method: "GET",
        };
        const params = {
          ...fetchOptions,
          headers: headers
        };
        fetch(api_url + images[0].image_url, params)
          .then((response) => response.blob())
          .then((blob: Blob) => {
            const imageUrl = URL.createObjectURL(blob);
            setBlobImage(imageUrl)
          }).catch();
      }
    }
  }, [images])

  useEffect(() => {
    if (fileList.length) {
      let newFieldData: Image[] = images;

      if (multiple) {
        newFieldData = [
          ...newFieldData,
          ...fileList.map((f) => {
            const image_url =
              //api_url +
              "/images/GetFile?type=Temp&filename=" +
              f.response.FileName +
              "&fileDownloadName=" +
              (f.name || "");
            return { image_guid: f.response.FileName, name: f.name, image_url };
          }),
        ];
      } else {
        const image_url =
          //api_url +
          "/images/GetFile?type=Temp&filename=" +
          fileList[0].response.FileName +
          "&fileDownloadName=" +
          (fileList[0].name || "");

        newFieldData = [
          {
            image_guid: fileList[0].response.FileName,
            name: fileList[0].name,
            image_url,
          },
        ];
      }

      setValue(imageField, newFieldData, { shouldDirty: true });

      setFileList([]);
    }
  }, [fileList, keepName]); // eslint-disable-line react-hooks/exhaustive-deps

  const removeImage = useCallback(
    (image: any) => {
      let newFieldData: Image[] = [];

      if (multiple) {
        newFieldData = images.filter((im: Image) => im.image_guid !== image);
      } else {
        newFieldData = [];
      }

      setValue(imageField, newFieldData, { shouldDirty: true });
    },

    [dataItem, imageField, multiple]
  );

  const handleChange = useCallback(
    (info: any) => {
      if (uploadRef.current) {
        if (info.file.status === "uploading") {
          return;
        }
        if (info.file.status === "error") {
          const responseFileInfo = info.file.response?.File;
          message.error(
            (responseFileInfo?.length && responseFileInfo[0]) ||
            `${t("unsupported_media_type")}: "${info.file.name}"`
          );
        }

        if (info.file.status === "done") {
          /* TODO document why this block is empty */
          /*NOSONAR*/
        }
        if (
          info.fileList.every(
            (f: any) => f.status === "done" || f.status === "error" || !f.status
          )
        ) {
          setFileList(info.fileList.filter((f: any) => f.status === "done"));
          // setLoading(false);
          //   hideLoader("upload");
          if (duplicateNames.current.length) {
            message.warning(t("dublicate_file_name"));
            duplicateNames.current = [];
          }
          uploadingCount.current = 0;
        }
      }
    },
    [duplicateNames]
  );
  // const beforeUpload = useCallback((file: any) => {
  //     showLoader("upload");
  //     setIsLoading(true);
  //     if (keepName && dataItem[imageField].some(im => im.name === file.name)) {
  //         duplicateNames.current = [...duplicateNames.current, file.name];
  //         return false;
  //     }
  //     uploadingCount.current += 1;

  //     if (uploadingCount.current > maxcount) {
  //         if (uploadingCount.current === maxcount + 1) {
  //             message.warning(<T args={[maxcount]}>message.only_max_count_file_will_be_processed</T>, 2)
  //         }
  //         return false;
  //     }

  //     return !keepName;
  // }, [dataItem, imageField, keepName]);

  const uploadButton = (
    <>
      <Button large accent type="button">
        <icon data-svg-size="16">
          <SvgDownload />
        </icon>
        {t("FO_COMP_IMPORT_LOGO")}
      </Button>
    </>
  );

  const innerContent = images && images[0] && (
    <>
      {anyFile ? (
        hideLink ? (
          <></>
        ) : (
          <a target="_blank" href={images[0].image_url}>
            {fileNameField
              ? dataItem[fileNameField]
              : images[0].name || images[0].image_guid}
          </a>
        ) /*eslint-disable-line react/jsx-no-target-blank*/ /*NOSONAR*/
      ) : (
        <>
          {blobImage ?
          <picture data-object-fit="contain">
            <img src={decodeURIComponent(encodeURIComponent(blobImage || images[0].image_url))} alt={alt || images.image_url} />
          </picture>
          :
          <group
                data-index="1"
                data-justify="center"
                data-align="center"
                data-gap="20"
                data-direction="group"
              >
                <icon data-svg-size="24" data-svg-color="black">
                  <SvgPicture />
                </icon>
              </group>}

          {!skipDeleteIcon ? (
            <button
              data-position="absolute"
              data-right="5"
              data-top="5"
              className="button micro rounded white"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                removeImage(images);
              }}
            >
              <icon data-svg-size="16" data-svg-color="main">
                <SvgDelete></SvgDelete>
              </icon>
            </button>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );

  return (
    <>
      {!fileList.length && (
        <>
          <group
            data-radius="extra-special"
            data-type="group"
            data-justify="center"
            data-align="center"
            data-ratio="1:1"
            data-length="150"
            data-border="dashed"
            data-border-color="main-color"
          >
            {innerContent || (
              <group
                data-index="1"
                data-justify="center"
                data-align="center"
                data-gap="20"
                data-direction="group"
              >
                <icon data-svg-size="24" data-svg-color="black">
                  <SvgPicture />
                </icon>
              </group>
            )}
          </group>

          <group data-space="10">
            <text data-color="grey-color-mid" data-wrap="wrap">
              {t("FO_COMP_FILE_FORMAT")}
            </text>
          </group>

          <Upload
            ref={uploadRef}
            name="file"
            accept={
              anyFile
                ? ".png, .jpg, .gif, .jpeg, .pdf, .mp4, .mov, .avi, .doc, .docx, .xls, .xlsx"
                : ".png, .jpg"
              //: ".png, .jpg, .gif, .jpeg"
            }
            //listType={listType || "picture-card"}
            multiple={multiple}
            className={className || "avatar-uploader"}
            showUploadList={showUploadList || false}
            action={api_url + (actionUrl || "/images/uploadfile?&type=" + type)}
            headers={{
              authorization: `Bearer ${getLocalStorageAccessToken()}`,
            }}
            // beforeUpload={beforeUpload} // { console.log(data, "beforeupload"); return data[0].name !='download (1) - Copy.jpeg'; }}
            onChange={handleChange}
            style={{ border: "1px dashed #40a9ff", padding: 32 }}
          >
            {uploadButton}
          </Upload>
        </>
      )}
    </>
  );
};

export default CustomUpload;
